import { ICommonUtilInterface } from "../../domain/common/common-util.interface";
import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { HttpService } from "../http/http";
import { IBlockRepository } from "../../domain/blocks/i-block.repository";
import { Block } from "../../domain/blocks/block";
import moment from "moment";
import { ChannelRepository } from "../../domain/channel-repository";
import { UserService } from "../../domain/user-service";
import { Auth, Token } from "../auth";
import { UserRepository } from "../../domain/user-repository";

@Injectable()
export class CachedBlocksRepository implements IBlockRepository {
  private _cache: Block[] = [];
  public updated = new Subject<Block>();
  public created = new Subject<Block>();
  public deleted = new Subject<Block>();
  constructor(
    private _commonUtils: ICommonUtilInterface,
    private _httpService: HttpService,
    private _channelRepository: ChannelRepository,
    private _userService: UserService,
    private _auth: Auth,
    private _userRepository: UserRepository,
  ) {
    console.log("CachedBlocksRepository->constructor()");
    /*this._cache.push(new Block(1000000845,'1000000845', 'dssdsddsds', 'Test Block 1000000845', 4, moment.duration(5, 'hours')));
    this._cache.push(new Block(1000000846,'1000000846', 'dssdsddsds', 'Test Block 1000000846', 6, moment.duration(7, 'hours')));*/
  }

  async init(): Promise<void> {
    const currentUser = this._userService.getCurrentUser();
    const allBlocks = await this._channelRepository.getAllChannels(
      currentUser.currentTenantId,
      false,
      false,
      false,
      true,
    );
    allBlocks.map((b) => {
      this._cache.push(b as Block);
    });
  }

  async create(name: string): Promise<Block> {
    const utcTimeZoneId = 22;
    const createChannelResult = await this._channelRepository.startCreate(
      name,
      utcTimeZoneId,
      null,
      null,
      null,
      null,
      true,
    );
    const newBlock = new Block(
      createChannelResult.channelId,
      createChannelResult.ChannelUid,
      "block channel",
      name,
      "",
      0,
      moment.duration(0, "hours"),
      false,
    );
    this._auth.token = new Token(
      createChannelResult.newAccessToken.token,
      createChannelResult.newAccessToken.tokenType,
      this._auth.token.expiry,
    );
    await this._userRepository.init();
    await this._channelRepository.save(newBlock, [], false);

    this._cache.push(newBlock);
    this.created.next(newBlock);
    return newBlock;
  }
  async update(block: Block): Promise<void> {
    /*const existingLayout = (await this.getLayouts(null, layout.id))[0];
    return this._httpService.post(`Layouts/CreateOrUpdate`, {
      Uid: layout.id,
      Name: layout.name,
      Zones: layout.zones.map(z => {
        return {
          ZoneType: z.zoneType,
          LiveFeedUid: (z.zoneType === ELayoutZoneType.liveFeed? z.mediaId : null),
          MediaId:   (z.zoneType === ELayoutZoneType.media? z.mediaId : null),
          GraphicsInstanceId:   (z.zoneType === ELayoutZoneType.gfx? z.mediaId : null),
          Volume: z.volume,
          ZIndex: z.zLayer,
          Index: z.index,
          PositionX: z.position.x,
          PositionY: z.position.y,
          PositionWidth: z.position.width,
          PositionHeight: z.position.height,
          CropSettings: z.cropSettings.toCropSettingsRequest(),
          OffsetFromBaseZoneMs: z.offsetFromBaseZoneMs,
          SomMs: z.somMs,
          DurationMs: z.durationMs
        }
      })
    }).then(() => {

      if (existingLayout) {
        this.updated.next(layout);
      } else {
        this.created.next(layout);
      }

    });*/
    try {
      await this._channelRepository.save(block, [], false);
      const existingBlock = (await this.get(null, block.id))[0];
      if (existingBlock) {
        this._cache[this._cache.indexOf(existingBlock)] = block;
        this.updated.next(block);
      }
    } catch (e) {
      return Promise.reject(e);
    }

    return Promise.resolve();
  }

  async delete(blockId: number): Promise<void> {
    const existingBlock = (await this.get(null, blockId))[0];
    if (existingBlock) {
      await this._channelRepository.deleteChannel(existingBlock);
      this._cache.splice(
        this._cache.indexOf(this._cache.find((l) => l.id === blockId)),
        1,
      );
      this.deleted.next(existingBlock);
    }

    return Promise.resolve();
    //return this._httpService.delete(`Layouts?Uid=${layoutId}`);
  }

  async get(nameFilter?: string, blockId?: number): Promise<Block[]> {
    let result = [];
    if (nameFilter && nameFilter.length > 0) {
      let text = nameFilter.toLowerCase();
      result = this._cache.filter((l) => l.name.toLowerCase().includes(text));
    } else {
      result = [...this._cache];
    }

    if (blockId && blockId > 0) {
      result = result.filter((l) => l.id === blockId);
    }

    return Promise.resolve(result);
  }
}
